// Single source of truth for the Algolia app id + search API key is
// app/components/new-navigation/keyword-contextual-search/ALGOLIA_CONFIG.ts.
// Do NOT hardcode a key here: a duplicated literal is how the revoked key
// kept shipping after the MR-2649 rotation (MR-2654).
import {
  ALGOLIA_API_KEY,
  ALGOLIA_APP_ID
} from 'app/components/new-navigation/keyword-contextual-search/ALGOLIA_CONFIG';

export const ALGOLIA_CONFIG = {
  appId: ALGOLIA_APP_ID,
  apiKey: ALGOLIA_API_KEY,
  indices: {
    apps: 'prod_v2_apps',
    suggestions: 'prod_v2_apps_query_suggestions'
  }
} as const;
